/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

const color = (row) => (row % 2 ? "#C3C4C5" : "#F5F3F3");

// eslint-disable-next-line no-unused-vars
const Responses = ({results}) => {
  if (!results) return;

  return results.map(({prime, elapsedTime:time}, i) => {

    const numFormat = (n) => {
      return n.toString(); //.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };


    var fTime = time/1000.0     // time is in milliseconds

    return (
    
      <div
        className="row"
        style={{
          // maxHeight: "3.4rem",
          backgroundColor: color(i),
        }}
        key={prime}
      >


        <div className="column">

          <span style={{wordBreak:"break-word", display:"table-cell", marginTop:"-1em"}}>{numFormat(prime)}</span>
          <br></br>
        </div>
        <div className="column">
          <span style={{marginTop:"-1em"}}>Time(sec): {fTime}</span>
        </div>
      </div>
      
    );
  });
};



export default ({ results }) => {
  return (
    <div>
      <div className="row">
        <div className="column">
          <span style={{ fontWeight: "bold" }}>
            Total calculation time:{" "}
            {results.reduce((ttl, {elapsedTime})=>ttl+elapsedTime, 0.0)/1000.0}
          </span>
        </div>
        <div className="column">
          Number of primes: {results.length}
        </div>
      </div>
      <label>Primes:</label>
      <Responses {...{results}} />
    </div>
  );
};
